const metrics = [
    {
        name: "collaboration-time",
        value: 7.52,
        oldValue: 5.09,
    },
    {
        name: "collaboration-network",
        value: 6.23,
        oldValue: 3.78,
    },
];

const overall = {
    value: 7.29,
    oldValue: 6.69,
};

const getCollaborationMiniIndexes = () => {
    return {
        metrics,
        overall,
    };
};

export default getCollaborationMiniIndexes;
